import { addToChainAfter, addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchCompleteLoadSession, PopulateApiParameter } from "@insite/client-framework/Store/Context/Handlers/SetFulfillmentMethod";

export const XngClearFulfillmentMethodIsChanging: any = (props: any) => {
    props.dispatch({
        type: "xCommon/fulfillmentMethod",
        isFulfillmentMethodUpdated: false,
    } as any);
};

export const XngSetFulfillmentMethodIsChanging: any = (props: any) => {
    props.dispatch({
        type: "xCommon/fulfillmentMethod",
        isFulfillmentMethodUpdated: true,
    } as any);
};

addToChainBefore(chain, PopulateApiParameter, XngClearFulfillmentMethodIsChanging);
addToChainAfter(chain, DispatchCompleteLoadSession, XngSetFulfillmentMethodIsChanging);
